import { SVGProps } from '../types';

const SkrillIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M14.3672 12.4551C15.6626 12.4551 16.3613 12.6625 16.9629 12.8779L16.9932 12.8867V14.6533L16.9707 14.6475C16.7293 14.5428 16.4453 14.4395 16.4453 14.4395C15.9358 14.2832 15.2227 14.1172 14.6719 14.1172C14.3585 14.1172 13.5248 14.1175 13.5244 14.7617C13.5244 15.2962 14.1051 15.335 14.3555 15.3516C16.1912 15.4777 17.285 16.3984 17.2852 17.8145C17.2852 19.0641 16.3069 20.3242 14.124 20.3242C13.112 20.3242 12.2483 20.2229 11.4824 20.0166V18.1973C11.9939 18.4127 12.837 18.6387 13.7051 18.6387C14.497 18.6386 14.9678 18.3702 14.9678 17.9141C14.9675 17.3621 14.3921 17.3281 14.1748 17.3145C11.6181 17.136 11.3428 15.5863 11.3428 14.9287C11.343 13.7868 12.1343 12.4552 14.3672 12.4551ZM19.8281 16.5225C20.5954 15.5721 20.912 14.6547 20.9561 14.54H23.2949C23.2282 14.7583 22.8105 16.0734 21.8594 17.3086C21.8594 17.3086 22.919 19.2099 23.1611 20.2412H20.7129C20.7129 20.2412 20.4202 18.8717 19.8281 17.9619V20.2412H17.7832V12.8691L19.8281 12.4551V16.5225ZM26.3311 14.4629C26.3375 14.4626 26.6632 14.4501 26.8564 14.4922V16.1572C25.6965 16.1982 25.5684 16.6271 25.5684 17.6279V20.2412H23.5703V17.0371C23.5705 15.3647 24.5008 14.5233 26.3311 14.4629ZM29.4297 20.2412H27.4482V14.5459H29.4297V20.2412ZM32.249 20.2412H30.2695V12.8184L32.249 12.4551V20.2412ZM35.1426 20.2412H33.1611V12.8184L35.1426 12.4551V20.2412ZM28.4385 12C28.978 12 29.4148 12.4479 29.415 13C29.415 13.5527 28.9781 14 28.4385 14C27.8997 14 27.4619 13.5527 27.4619 13C27.4621 12.4478 27.8999 12 28.4385 12Z"
      fill="#862165"
    />
  </svg>
);

export { SkrillIcon };
